/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = function () { "use strict"; function t(t, e) { return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + t + "' height='" + e + "'%3E%3C/svg%3E" } function e(t) { if (t.srcset && !p && window.picturefill) { var e = window.picturefill._; t[e.ns] && t[e.ns].evaled || e.fillImg(t, { reselect: !0 }), t[e.ns].curSrc || (t[e.ns].supported = !1, e.fillImg(t, { reselect: !0 })), t.currentSrc = t[e.ns].curSrc || t.src } } function i(t) { for (var e, i = getComputedStyle(t).fontFamily, r = {}; null !== (e = u.exec(i));)r[e[1]] = e[2]; return r } function r(e, i, r) { var n = t(i || 1, r || 0); b.call(e, "src") !== n && h.call(e, "src", n) } function n(t, e) { t.naturalWidth ? e(t) : setTimeout(n, 100, t, e) } function c(t) { var c = i(t), o = t[l]; if (c["object-fit"] = c["object-fit"] || "fill", !o.img) { if ("fill" === c["object-fit"]) return; if (!o.skipTest && f && !c["object-position"]) return } if (!o.img) { o.img = new Image(t.width, t.height), o.img.srcset = b.call(t, "data-ofi-srcset") || t.srcset, o.img.src = b.call(t, "data-ofi-src") || t.src, h.call(t, "data-ofi-src", t.src), t.srcset && h.call(t, "data-ofi-srcset", t.srcset), r(t, t.naturalWidth || t.width, t.naturalHeight || t.height), t.srcset && (t.srcset = ""); try { s(t) } catch (t) { window.console && console.warn("https://bit.ly/ofi-old-browser") } } e(o.img), t.style.backgroundImage = 'url("' + (o.img.currentSrc || o.img.src).replace(/"/g, '\\"') + '")', t.style.backgroundPosition = c["object-position"] || "center", t.style.backgroundRepeat = "no-repeat", t.style.backgroundOrigin = "content-box", /scale-down/.test(c["object-fit"]) ? n(o.img, function () { o.img.naturalWidth > t.width || o.img.naturalHeight > t.height ? t.style.backgroundSize = "contain" : t.style.backgroundSize = "auto" }) : t.style.backgroundSize = c["object-fit"].replace("none", "auto").replace("fill", "100% 100%"), n(o.img, function (e) { r(t, e.naturalWidth, e.naturalHeight) }) } function s(t) { var e = { get: function (e) { return t[l].img[e ? e : "src"] }, set: function (e, i) { return t[l].img[i ? i : "src"] = e, h.call(t, "data-ofi-" + i, e), c(t), e } }; Object.defineProperty(t, "src", e), Object.defineProperty(t, "currentSrc", { get: function () { return e.get("currentSrc") } }), Object.defineProperty(t, "srcset", { get: function () { return e.get("srcset") }, set: function (t) { return e.set(t, "srcset") } }) } function o() { function t(t, e) { return t[l] && t[l].img && ("src" === e || "srcset" === e) ? t[l].img : t } d || (HTMLImageElement.prototype.getAttribute = function (e) { return b.call(t(this, e), e) }, HTMLImageElement.prototype.setAttribute = function (e, i) { return h.call(t(this, e), e, String(i)) }) } function a(t, e) { var i = !y && !t; if (e = e || {}, t = t || "img", d && !e.skipTest || !m) return !1; "img" === t ? t = document.getElementsByTagName("img") : "string" == typeof t ? t = document.querySelectorAll(t) : "length" in t || (t = [t]); for (var r = 0; r < t.length; r++)t[r][l] = t[r][l] || { skipTest: e.skipTest }, c(t[r]); i && (document.body.addEventListener("load", function (t) { "IMG" === t.target.tagName && a(t.target, { skipTest: e.skipTest }) }, !0), y = !0, t = "img"), e.watchMQ && window.addEventListener("resize", a.bind(null, t, { skipTest: e.skipTest })) } var l = "fregante:object-fit-images", u = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g, g = "undefined" == typeof Image ? { style: { "object-position": 1 } } : new Image, f = "object-fit" in g.style, d = "object-position" in g.style, m = "background-size" in g.style, p = "string" == typeof g.currentSrc, b = g.getAttribute, h = g.setAttribute, y = !1; return a.supportsObjectFit = f, a.supportsObjectPosition = d, o(), a }();

if ($('.slider-img').length) {
	$('.slider-img').slick({
		autoplay: true,
		dots: false,
		arrows: true,
		infinite: true,
		prevArrow: '<div class="prev slick-arrow"></div>',
		nextArrow: '<div class="next slick-arrow"></div>',
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					autoplay: true,
					dots: false,
					arrows: true,
					infinite: true,
					prevArrow: '<div class="prev slick-arrow"></div>',
					nextArrow: '<div class="next slick-arrow"></div>',
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 650,
				settings: {
					autoplay: true,
					dots: false,
					arrows: true,
					infinite: true,
					prevArrow: '<div class="prev slick-arrow"></div>',
					nextArrow: '<div class="next slick-arrow"></div>',
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
};

$.fn.accordion = function () {
	$(this).each(function () {

		var $btn = $(this);
		var $target = $(this).next();

		if ($(this).data('accordion-open')) {
			$target.show();
			$btn.addClass('-active');
		} else {
			$target.hide();
		}

		$btn.on('click', function () {
			$target.stop().slideToggle();
			$btn.toggleClass('-active');
		});
	});
}

$.pagetop = function () {
	var $btn = $('.site-nav-btn');
	var $nav = $('.site-menu');
	var $header = $('.site-header');
	var $pagetop = $('.site-pagetop');
	var $body = $('body');
	var _y = 0;
	var _activeClass = '-active';
	var _scrolledClass = '-scrolled';
	var _isOpen = false;

	$btn.on('click', function () {

		if (_isOpen) {
			_isOpen = false;
			$btn.removeClass(_activeClass);
			$nav.removeClass(_activeClass);
			$body.removeClass(_activeClass);
		} else {
			_isOpen = true;
			$btn.addClass(_activeClass);
			$nav.addClass(_activeClass);
			$body.addClass(_activeClass);
		}
	})

	var _headerHeight = $header.height();

	$(window).on('scroll', function () {
		_y = $(this).scrollTop();

		if (_y > _headerHeight) {
			$pagetop.addClass(_scrolledClass);
			$header.addClass(_scrolledClass);
		} else {
			$pagetop.removeClass(_scrolledClass);
			$header.removeClass(_scrolledClass);
		}
	});
}

$.smoothScroll = function (_o) {
	var _c = $.fn.extend({
		selector: 'a[href^="#"], a[href^="' + location.pathname + '#"]',
		time: 1000
	}, _o);

	var _selector = _c.selector,
		_time = _c.time,
		_headerHeight;

	// var _diff = ua.isMobile ? 70 : 188;
	var _diff = $('.site-header').height() + 30;
	var _not = $('.fancybox-button,.fancybox-content .btn a,.sec-omikuji__recipe__btn a,.sec-omikuji__share a,.tab-products-btn__item a, .tab-permalink a, [data-tab], [data-fancybox],a#omikuji-contents,.top-slider-campaign .prev,.top-slider-campaign .next,.slider-contents .prev,.slider-contents .next,.sample-omikuji a');

	$.extend($.easing, { easeOutExpo: function (x, t, b, c, d) { return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b; } });

	$(_selector).not(_not).on('click', function () {
		var _href = $(this).attr('href').replace(location.pathname, '');
		if (_href != "#") {
			var _posY = 0;
			if (_href != "#top") _posY = $(_href).offset().top;
			$('html, body').animate({
				scrollTop: _posY - _diff
			}, _time, 'easeOutExpo');
		}

		return false;
	});
}

$.fn.scrollAnimation = function (elem) {

	var _wy = 0;
	var _wh = window.innerHeight;
	var _mag = 0.8;

	window.addEventListener('scroll', function () {
		_wy = $(window).scrollTop();
	})
	window.addEventListener('resize', function () {
		_wh = $(window).height();
	})

	_wy = $(window).scrollTop();

	$(this).each(function () {
		var _self = this;
		var _interval = 0;

		this.targetPosY = $(this).offset().top;

		window.addEventListener('load', function () {
			_self.targetPosY = $(_self).offset().top;
		});

		window.addEventListener('scroll', scrollEvent);
		window.addEventListener('load', loadEvent);

		function scrollEvent() {
			_self.targetPosY = $(_self).offset().top;

			if (_wy + _wh * _mag > _self.targetPosY) {
				window.removeEventListener('scroll', scrollEvent);
				$(_self).addClass("-run");

			}
		}
		function loadEvent() {
			if (_wy + _wh * _mag > _self.targetPosY) {

				window.removeEventListener('scroll', scrollEvent);

				setTimeout(function () {
					$(_self).addClass("-run");
				}, _interval * 1000)
			}
		}
	});
}

var hash = location.hash;
if (hash.length > 0) {
	location.href = hash + '_';
	$(window).on('load', function () {
		if ($(hash).length) {
			var offset = $(hash).offset();
			var top = offset !== undefined ? offset.top : 0;
			var _diff = $(window).width() < 993 ? 80 : 130;

			setTimeout(function () {
				offset = $(hash).offset();
				top = offset.top;
				$(window).scrollTop(top - _diff);
			}, 300);
			setTimeout(function () {
				$(window).scrollTop(top - _diff + 2);
			}, 320);

			history.replaceState(null, '', hash);
		} else {
			history.replaceState(null, '', hash);
		};
	});
};

$.fn.inviewClass = function(options){

	var settings = $.extend({
		className: '-run',
		secondClassName: '-run-sec',
		visibleOffset: 0,
		secondClassInterval: 1000
	}, options);

	var isDisabled = false;
	if(settings.SecondClassName === ''){
		isDisabled = true;
	}

	var currentPos;

	return this.each(function(){
		var $this = $(this);
		function inviewClass(){
			currentPos = pageYOffset;
			if(currentPos > $this.offset().top - window.innerHeight + settings.visibleOffset){
				if(!$this.hasClass(settings.className)){
					$this.addClass(settings.className)
					if(!isDisabled){
						var thisTimeoutID = setTimeout(function(){
							$this.addClass(settings.secondClassName);
							clearTimeout(thisTimeoutID);
						}, settings.secondClassInterval);
					}

				}
			}

		}

		inviewClass();

		$(window).on('resize', function(){
			inviewClass();
		});

		$(window).on('scroll', function(){
			inviewClass();
		});
	})

}


$(function(){
	$('.-sa').inviewClass();
	var nav = $('.site-header');
	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 20) {
			nav.addClass('-scrolled');
		} else {
			nav.removeClass('-scrolled');
		}
	});

	$('.local-nav li a').each(function(){
		var $href = $(this).attr('href');
		if(location.href.match($href)) {
			$(this).parent('.local-nav li').addClass('-current');
		} else {
			$(this).parent('.local-nav li').removeClass('-current');
		}
	});

	//navの位置
	var navTop = nav.offset().top;
	//スクロールするたびに実行
	$(window).on('scroll', function () {
		var winTop = $(window).scrollTop();
		//スクロール位置がnavの位置より下だったらクラスfixedを追加
		if (winTop >= navTop) {
			nav.addClass('-fixed')
		} else if (winTop <= navTop) {
			nav.removeClass('-fixed')
		};

		$(".marker").each(function () {
			var position = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > position - windowHeight) {
				$(this).addClass('-active');
			}
		});
	});

	$(window).on('resize', function (event) {
		//navの位置
		navTop = nav.offset().top;
		$(this).trigger('scroll');
	});

	$.smoothScroll();
	$('.-animation').scrollAnimation();
	$('.c-faq > dt,[data-accordion]').accordion();
	$.pagetop();
	$(".site-pagetop").hide();
	$('.biggerlink').on('click', function (e) {
		e.preventDefault();
		let href = $(this).find('a').attr('href');
		let target = $(this).find('a').attr('target') ? $(this).find('a').attr('target') : '_self';
		window.open(href, target);
	});
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 100) {
			$(".site-pagetop").fadeIn("fast");
		} else {
			$(".site-pagetop").fadeOut("fast");
		}
		let scrollHeight = $(document).height();
		let scrollPosition = $(window).height() + $(window).scrollTop();
		let footHeight = $(".site-footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
			if ($(this).width() < 1280) {
				$(".site-pagetop").css({
					"position": "absolute",
					"bottom": footHeight + 20
					// "bottom": footHeight + 20
				});
			} else if ($(this).width() < 1120) {
				$(".site-pagetop").css({
					"position": "absolute",
					"bottom": footHeight + 100
					// "bottom": footHeight + 20
				});
			} else if ($(this).width() < 768) {
				$(".site-pagetop").css({
					"position": "absolute",
					"bottom": footHeight + 200
					// "bottom": footHeight + 20
				});
			} else {
				$(".site-pagetop").css({
					"position": "absolute",
					"bottom": footHeight + 60
					// "bottom": footHeight + 20
				});
			}
		}
		else {
			$(".site-pagetop").css({
				"position": "",
				"bottom": ""
			});
		}
	});
	$('.site-pagetop').on('click', function () {
		$('body,html').animate({
			scrollTop: 0
		}, 400);
		return false;
	});
	if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0 || $(window).width() < 1520) {
		return $('.swipe').each(function () {
			var btn;
			if ($(this).children().width() > 300) {
				btn = $('<div class="swipe-icon"></div>');
				$(this).append(btn);
				$(this).on('touchmove mousemove', function () {
					return btn.remove();
				});
				return $(this).on('touchend mouseleave', function () {
					return $(this).append(btn);
				});
			}
		});
	}
	if ($('.site-header__body').length) {
		var pageURL = location.pathname,
			pageURLArr = pageURL.split('/'),
			pageURLArrCategory = pageURLArr[1],
			pageURLArrCategoryChild = pageURLArr[2];

		if (pageURLArrCategory) {
			pageURLArrCategory = pageURLArrCategory.replace('.html', '');
		}
		if (pageURLArrCategoryChild) {
			pageURLArrCategoryChild = pageURLArrCategoryChild.replace('.html', '');
		}


		$('.site-header__body > ul > li > a').each(function (i, elem) {
			var selfhref = $(elem).attr('href'),
				hrefArr = selfhref.split('/'),
				hrefArrCategory = hrefArr[1];

			if (selfhref.indexOf('http') !== 0) {
				if (hrefArrCategory) {
					hrefArrCategory = hrefArrCategory.replace('.html', '');
				}

				if (pageURLArrCategory === hrefArrCategory) {
					$(elem).parent().addClass('-current');

					if ($(elem).next().length) {
						$(elem).next().find('a').each(function (i, elem) {
							selfhref = $(elem).attr('href'),
								hrefArr = selfhref.split('/'),
								hrefArrCategory = hrefArr[2];

							if (selfhref.indexOf('http') !== 0) {
								if (hrefArrCategory) {
									hrefArrCategory = hrefArrCategory.replace('.html', '');
								}

								if (pageURLArrCategoryChild === hrefArrCategory) {
									$(elem).parent().addClass('-current');
								}
							}
						})
					}
				}
			}
		});
	};
});